import {
  apiBaseUrl
} from 'yxt-biz-pc/packages/api';

export const getDictsOrg = (data) => { // 管理端查询字典列表
  return apiBaseUrl.get('/sptalentsd/mgr/dicts/org', data);
};

export const getSkillModelList = (data, params) => {
  return apiBaseUrl.post('/sptalentsd/mgr/model/skillmodel/page', data, { params });
};

export const checkSkillModel = (id) => {
  return apiBaseUrl.get(`/sptalentsd/mgr/model/skillmodel/check/${id}`);
};
